
import React from "react";

function Default() {
  return (
    <>
      {/* =========================
          NAVBAR
      ========================== */}
      {/* <nav className="navbar navbar-expand-lg">
        <div className="container">
          <a className="navbar-brand" href="#home">
            Sadhana Kumar, MD
          </a>

          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#menu"
            aria-controls="menu"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          <div className="collapse navbar-collapse" id="menu">
            <ul className="navbar-nav ms-auto align-items-lg-center">
              <li className="nav-item">
                <a className="nav-link" href="#home">
                  Home
                </a>
              </li>

              <li className="nav-item">
                <a className="nav-link" href="#about">
                  About
                </a>
              </li>

              <li className="nav-item">
                <a className="nav-link" href="#services">
                  Services
                </a>
              </li>

              <li className="nav-item">
                <a className="nav-link" href="#contact">
                  Contact
                </a>
              </li>

              <li className="ms-lg-4 mt-3 mt-lg-0">
                <a href="#appointment" className="book-btn">
                  Book Appointment
                </a>
              </li>
            </ul>
          </div>
        </div>
      </nav> */}

      {/* =========================
          HERO SECTION
      ========================== */}
      <section className="hero" id="home">
        <div className="container">
          <div className="row align-items-center gy-5">
            <div className="col-lg-6">
              <span className="badge-top">
                <i className="bi bi-heart-pulse-fill me-2"></i>
                Trusted Healthcare Since 1999
              </span>

              <h1>
                Your Health.
                <br />
                Our Lifelong Commitment.
              </h1>

              <p>
                Experience compassionate healthcare delivered by highly
                qualified physicians, advanced technology, and personalized
                treatment plans designed around your family's well-being.
              </p>

              <div className="d-flex flex-wrap gap-3">
                <a
                  href="#contact"
                  className="btn-primary-custom text-decoration-none"
                >
                  Book Appointment
                </a>

                <a
                  href="#services"
                  className="btn-outline-custom text-decoration-none"
                >
                  Explore Services
                </a>
              </div>

              <div className="stats">
                <div className="stat">
                  <h2>25+</h2>
                  <span>Years Experience</span>
                </div>

                <div className="stat">
                  <h2>180+</h2>
                  <span>Doctors</span>
                </div>

                <div className="stat">
                  <h2>150K+</h2>
                  <span>Happy Patients</span>
                </div>
              </div>
            </div>

            <div className="col-lg-6">
              <div className="hero-image">
                <img
                  src="https://images.unsplash.com/photo-1594824476967-48c8b964273f?auto=format&fit=crop&w=600&q=80"
                  alt="Professional Doctor"
                />

                <div className="floating-card">
                  <div className="d-flex align-items-center mb-3">
                    <i className="bi bi-calendar-check-fill fs-2 text-primary me-3"></i>

                    <div>
                      <h4>Appointments</h4>
                      <small className="text-muted">
                        Available Today
                      </small>
                    </div>
                  </div>

                  <hr />

                  <div className="d-flex justify-content-between">
                    <div>
                      <strong>98%</strong>
                      <br />
                      <small>Success Rate</small>
                    </div>

                    <div>
                      <strong>24/7</strong>
                      <br />
                      <small>Emergency</small>
                    </div>
                  </div>
                </div>

                <div className="rating-card">
                  <div className="mb-2">
                    <i className="bi bi-star-fill text-warning"></i>
                    <i className="bi bi-star-fill text-warning"></i>
                    <i className="bi bi-star-fill text-warning"></i>
                    <i className="bi bi-star-fill text-warning"></i>
                    <i className="bi bi-star-fill text-warning"></i>
                  </div>

                  <h5 className="mb-1">4.9/5 Rating</h5>

                  <small className="text-muted">
                    Trusted by 150,000+ Patients
                  </small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

     

      {/* =========================
          SERVICES
      ========================== */}
     

      {/* =========================
          DOCTORS
      ========================== */}
      <section id="doctors" className="doctor-section">
        <div className="container">
          <div className="text-center mb-5">
            <span className="section-subtitle">OUR SPECIALISTS</span>

            <h2 className="section-title">Meet Our Expert Doctors</h2>

            <p
              className="section-text mx-auto"
              style={{ maxWidth: "720px" }}
            >
              Our multidisciplinary team of highly qualified physicians is
              committed to providing compassionate, evidence-based care for
              every patient.
            </p>
          </div>

          <div className="row g-4">
            {[
              {
                image:
                  "https://images.unsplash.com/photo-1612349317150-e413f6a5b16d?auto=format&fit=crop&w=600&q=80",
                name: "Dr. Michael Carter",
                specialty: "Cardiologist",
                experience: "15+ Years Experience",
              },
              {
                image:
                  "https://images.unsplash.com/photo-1594824476967-48c8b964273f?auto=format&fit=crop&w=600&q=80",
                name: "Dr. Emily Wilson",
                specialty: "Pediatrician",
                experience: "12+ Years Experience",
              },
              {
                image:
                  "https://images.unsplash.com/photo-1559839734-2b71ea197ec2?auto=format&fit=crop&w=600&q=80",
                name: "Dr. Sarah Johnson",
                specialty: "Neurologist",
                experience: "18+ Years Experience",
              },
              {
                image:
                  "https://images.unsplash.com/photo-1622253692010-333f2da6031d?auto=format&fit=crop&w=600&q=80",
                name: "Dr. David Brown",
                specialty: "Orthopedic Surgeon",
                experience: "25+ Years Experience",
              },
            ].map((doctor, index) => (
              <div className="col-lg-3 col-md-6" key={index}>
                <div className="doctor-card">
                  <img src={doctor.image} alt={doctor.name} />

                  <h4>{doctor.name}</h4>

                  <span>{doctor.specialty}</span>

                  <p>{doctor.experience}</p>

                  <div className="doctor-social">
                    <a href="#" aria-label="Facebook">
                      <i className="bi bi-facebook"></i>
                    </a>

                    <a href="#" aria-label="LinkedIn">
                      <i className="bi bi-linkedin"></i>
                    </a>

                    <a href="#" aria-label="Twitter">
                      <i className="bi bi-twitter-x"></i>
                    </a>
                  </div>

                  <a href="#contact" className="doctor-btn">
                    Book Appointment
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* =========================
          STATISTICS
      ========================== */}
      <section className="stats-strip">
        <div className="container">
          <div className="row text-center">
            <div className="col-lg-3 col-6">
              <h2 className="counter">25+</h2>
              <p>Years Experience</p>
            </div>

            <div className="col-lg-3 col-6">
              <h2 className="counter">180+</h2>
              <p>Doctors</p>
            </div>

            <div className="col-lg-3 col-6">
              <h2 className="counter">150K+</h2>
              <p>Patients Served</p>
            </div>

            <div className="col-lg-3 col-6">
              <h2 className="counter">98%</h2>
              <p>Patient Satisfaction</p>
            </div>
          </div>
        </div>
      </section>

      {/* =========================
          TESTIMONIALS
      ========================== */}
      <section id="testimonials" className="testimonial-section">
        <div className="container">
          <div className="text-center mb-5">
            <span className="section-subtitle">TESTIMONIALS</span>

            <h2 className="section-title">What Our Patients Say</h2>

            <p
              className="section-text mx-auto"
              style={{ maxWidth: "700px" }}
            >
              Thousands of patients trust Dr. Sadhana Kumar MD for
              compassionate, high-quality medical care and exceptional
              healthcare experiences.
            </p>
          </div>

          <div
            id="testimonialCarousel"
            className="carousel slide"
            data-bs-ride="carousel"
          >
            <div className="carousel-inner">
              <div className="carousel-item active">
                <div className="testimonial-card">
                  <div className="stars">★★★★★</div>

                  <p>
                    "The doctors were incredibly professional and caring. From
                    consultation to recovery, the experience was exceptional."
                  </p>

                  <h5>Jennifer Williams</h5>

                  <small>Cardiology Patient</small>
                </div>
              </div>

              <div className="carousel-item">
                <div className="testimonial-card">
                  <div className="stars">★★★★★</div>

                  <p>
                    "Modern facilities, friendly staff, and excellent
                    healthcare services. Highly recommended."
                  </p>

                  <h5>Robert Miller</h5>

                  <small>Orthopedic Patient</small>
                </div>
              </div>

              <div className="carousel-item">
                <div className="testimonial-card">
                  <div className="stars">★★★★★</div>

                  <p>
                    "Booking appointments was simple and the doctors explained
                    every treatment clearly."
                  </p>

                  <h5>Sophia Davis</h5>

                  <small>Family Care</small>
                </div>
              </div>
            </div>

            <button
              className="custom-carousel-control-prev"
              type="button"
              data-bs-target="#testimonialCarousel"
              data-bs-slide="prev"
              aria-label="Previous testimonial"
            >
              <span
                className="custom-carousel-control-prev-icon"
                style={{ background: "none" }}
              >
                <i className="bi bi-arrow-left fs-3"></i>
              </span>
            </button>

            <button
              className="custom-carousel-control-next"
              type="button"
              data-bs-target="#testimonialCarousel"
              data-bs-slide="next"
              aria-label="Next testimonial"
            >
              <span
                className="custom-carousel-control-next-icon"
                style={{ background: "none" }}
              >
                <i className="bi bi-arrow-right fs-3"></i>
              </span>
            </button>
          </div>
        </div>
      </section>

      {/* =========================
          FAQ
      ========================== */}
      <section className="faq-section">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-5">
              <span className="section-subtitle">FAQ</span>

              <h2 className="section-title">
                Frequently Asked Questions
              </h2>

              <p className="section-text">
                Find answers to the most common questions about appointments,
                insurance, consultations, and our healthcare services.
              </p>
            </div>

            <div className="col-lg-7">
              <div className="accordion" id="faqAccordion">
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <button
                      className="accordion-button"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#faq1"
                      aria-expanded="true"
                    >
                      Do I need an appointment?
                    </button>
                  </h2>

                  <div
                    id="faq1"
                    className="accordion-collapse collapse show"
                    data-bs-parent="#faqAccordion"
                  >
                    <div className="accordion-body">
                      We recommend appointments for faster service, although
                      emergency care is always available.
                    </div>
                  </div>
                </div>

                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#faq2"
                      aria-expanded="false"
                    >
                      Do you accept insurance?
                    </button>
                  </h2>

                  <div
                    id="faq2"
                    className="accordion-collapse collapse"
                    data-bs-parent="#faqAccordion"
                  >
                    <div className="accordion-body">
                      Yes. We work with most major insurance providers.
                    </div>
                  </div>
                </div>

                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#faq3"
                      aria-expanded="false"
                    >
                      Is telemedicine available?
                    </button>
                  </h2>

                  <div
                    id="faq3"
                    className="accordion-collapse collapse"
                    data-bs-parent="#faqAccordion"
                  >
                    <div className="accordion-body">
                      Yes. Secure online consultations are available for
                      eligible services.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* =========================
          CALL TO ACTION
      ========================== */}
      <section className="cta-section">
        <div className="container">
          <div className="cta-box text-center">
            <h2>Ready to Prioritize Your Health?</h2>

            <p>
              Schedule your appointment today and experience compassionate,
              personalized healthcare from our trusted medical professionals.
            </p>

            <a
              href="#contact"
              className="btn-primary-custom text-decoration-none"
            >
              Book Your Appointment
            </a>
          </div>
        </div>
      </section>

      {/* =========================
          CONTACT
      ========================== */}
     

      {/* =========================
          FOOTER
      ========================== */}
      <footer>
        <div className="container">
          <div className="row gy-5">
            <div className="col-lg-4">
              <h3 className="footer-logo">
                Sadhana Kumar, MD | Nephrology | Parsippany, NJ
              </h3>

              <p>
                Providing trusted healthcare with compassion, innovation, and
                excellence.
              </p>
            </div>

            <div className="col-lg-2">
              <h5>Quick Links</h5>

              <ul>
                <li>
                  <a href="#home">Home</a>
                </li>
                <li>
                  <a href="#about">About</a>
                </li>
                <li>
                  <a href="#services">Services</a>
                </li>
                <li>
                  <a href="#contact">Contact</a>
                </li>
              </ul>
            </div>

            <div className="col-lg-3">
              <h5>Services</h5>

              <ul>
                <li>Nephrology</li>
                <li>General Nephrology</li>
                <li>Diagnostics</li>
                <li>Telemedicine</li>
              </ul>
            </div>

            <div className="col-lg-3">
              <h5>Newsletter</h5>

              <input
                type="email"
                className="form-control mb-3"
                placeholder="Email Address"
              />

              <button type="button" className="btn-primary-custom w-100">
                Subscribe
              </button>
            </div>
          </div>

          <hr />

          <div className="text-center">
            © 2026 Sadhana Kumar, MD. All Rights Reserved.
          </div>
        </div>
      </footer>

      {/* Back to top */}
      <button
        id="topBtn"
        type="button"
        aria-label="Back to top"
        onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      >
        <i className="bi bi-arrow-up"></i>
      </button>
    </>
  );
}

export default Default;

